module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/32x32_outline_hexagon-46d8013260b7892c02b4d535ce205d63.svg";